/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import UiSelectWithGraphicsGroup from './UiSelectWithGraphicsGroup'
import UiSelectWithGraphicsOption from './UiSelectWithGraphicsOption'
import {UiSelectOption} from '../UiSelectWithGraphics'

interface UiSelectWithGraphicsOptionsListProps {
    groupedOptions?: { groupLabel: string; options: UiSelectOption[] }[]
    options: UiSelectOption[]
    wrapOptionLabels?: boolean
}

const UiSelectWithGraphicsOptionsList = (
    props: UiSelectWithGraphicsOptionsListProps
) => {
    const hasGrouped =
        Array.isArray(props.groupedOptions) && props.groupedOptions.length > 0

    if (hasGrouped) {
        return (
            <>
                {props.groupedOptions?.map((group, index) => (
                    <UiSelectWithGraphicsGroup
                        key={`group-${index}`}
                        group={group}
                    />
                ))}
            </>
        )
    }

    if (!props.options.length) {
        return null
    }

    const sortedOptions = [...props.options].sort((a, b) => {
        const aPosition = typeof a.position === 'number' ? a.position : Number.MAX_SAFE_INTEGER
        const bPosition = typeof b.position === 'number' ? b.position : Number.MAX_SAFE_INTEGER

        if (aPosition !== bPosition) {
            return aPosition - bPosition
        }

        return String(a.label ?? '').localeCompare(String(b.label ?? ''))
    })

    return (
        <>
            {sortedOptions.map((option) => (
                <UiSelectWithGraphicsOption
                    key={option.value}
                    option={option}
                    wrapOptionLabels={props.wrapOptionLabels}
                />
            ))}
        </>
    )
}

export default UiSelectWithGraphicsOptionsList
